import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';

function SocialMediaProsWorkshop() {
    const { user, isMember, isAdmin } = useAuth();
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        if (user && (isMember || isAdmin)) {
            fetchInvoices();
        }
    }, [user, isMember, isAdmin]);

    const fetchInvoices = async () => {
        try {
            const res = await fetch('/api/member/invoices', {
                headers: { 'Authorization': `Bearer ${user?.token}` }
            });
            const data = await res.json();
            if (data.data) {
                setInvoices(data.data);
            }
        } catch (err) {
            console.error('Fehler beim Laden der Rechnungen:', err);
        }
    };

    const downloadPDF = async (invoiceId, invoiceNumber) => {
        try {
            const res = await fetch(`/api/member/invoices/${invoiceId}/pdf`, {
                headers: { 'Authorization': `Bearer ${user?.token}` }
            });
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Rechnung_${invoiceNumber}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            alert('Fehler beim Download: ' + err.message);
        }
    };

    const formatCurrency = (amount) => parseFloat(amount || 0).toFixed(2) + ' EUR';

    const getStatusBadge = (status) => {
        if (status === 'paid') return <span className="badge bg-success">Bezahlt</span>;
        return <span className="badge bg-warning">Offen</span>;
    };

    if (!user) {
        return (
            <div className="text-center py-5">
                <div className="card mx-auto" style={{ maxWidth: '500px' }}>
                    <div className="card-body p-5">
                        <h2 className="mb-4">Pfingstcamp: Social Media Pros</h2>
                        <p className="text-muted mb-4">
                            Dieser Bereich ist nur für angemeldete Mitglieder zugänglich.
                        </p>
                        <Link to="/login" className="btn btn-primary">Jetzt anmelden</Link>
                    </div>
                </div>
            </div>
        );
    }

    if (!isMember && !isAdmin) {
        return (
            <div className="text-center py-5">
                <div className="card mx-auto" style={{ maxWidth: '500px' }}>
                    <div className="card-body p-5">
                        <h2 className="mb-4">Zugang nicht möglich</h2>
                        <p className="text-muted">Dieser Bereich ist nur für Mitglieder zugänglich.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="social-media-pros-workshop">
            {/* Hero */}
            <div className="card mb-4" style={{
                background: 'linear-gradient(135deg, #f810b1, #9b59b6, #324047)',
                color: 'white',
                border: 'none'
            }}>
                <div className="card-body text-center py-5">
                    <p className="mb-2" style={{ opacity: 0.8, fontSize: '1.1rem' }}>Pfingstcamp 2026 · Woche 1</p>
                    <h1 className="mb-3" style={{ color: 'white' }}>Social Media Pros</h1>
                    <p className="mb-3" style={{ opacity: 0.9, fontSize: '1.15rem' }}>
                        Hinter die Kulissen schauen. Den eigenen Schutzschild bauen. Und ja, auch was Eigenes machen.
                    </p>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <span className="badge" style={{ background: 'rgba(255,255,255,0.2)', fontSize: '0.9rem' }}>
                            26. - 29. Mai 2026
                        </span>
                        <span className="badge" style={{ background: 'rgba(255,255,255,0.2)', fontSize: '0.9rem' }}>
                            Di - Fr · 09:00 - 13:00
                        </span>
                        <span className="badge" style={{ background: 'rgba(255,255,255,0.2)', fontSize: '0.9rem' }}>
                            8 - 10 Jahre
                        </span>
                    </div>
                </div>
            </div>

            {/* Eltern-Recap: Was haben wir gemacht? */}
            <div className="mb-4">
                <h5 className="mb-3" style={{ color: '#324047' }}>Liebe Eltern: Was haben wir gemacht?</h5>
                <div className="row g-3">
                    <div className="col-md-6">
                        <a href="/pfingsten-2026/eltern-tag-1.html" className="text-decoration-none">
                            <div className="card h-100 hover-lift" style={{
                                background: 'linear-gradient(135deg, #f810b1, #9b59b6)',
                                color: 'white',
                                border: 'none'
                            }}>
                                <div className="card-body d-flex align-items-center" style={{ gap: '14px' }}>
                                    <div style={{ fontSize: '1.8rem' }}>📱</div>
                                    <div style={{ flex: 1 }}>
                                        <h6 className="mb-1" style={{ color: 'white' }}>Tag 1 — Bilder &amp; Instagram</h6>
                                        <p className="mb-0 small" style={{ opacity: 0.92 }}>Werke und Posts eures Kindes.</p>
                                    </div>
                                    <div style={{ fontWeight: 700, opacity: 0.9 }}>→</div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <a href="/pfingsten-2026/eltern-tag-2.html" className="text-decoration-none">
                            <div className="card h-100 hover-lift" style={{
                                background: 'linear-gradient(135deg, #ff6b35, #e74c3c)',
                                color: 'white',
                                border: 'none'
                            }}>
                                <div className="card-body d-flex align-items-center" style={{ gap: '14px' }}>
                                    <div style={{ fontSize: '1.8rem' }}>🧠</div>
                                    <div style={{ flex: 1 }}>
                                        <h6 className="mb-1" style={{ color: 'white' }}>Tag 2 — Algorithmen &amp; Schutzschild</h6>
                                        <p className="mb-0 small" style={{ opacity: 0.92 }}>Eindrücke vom Champion-Algorithmus-Tag.</p>
                                    </div>
                                    <div style={{ fontWeight: 700, opacity: 0.9 }}>→</div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <a href="/pfingsten-2026/eltern-tag-3.html" className="text-decoration-none">
                            <div className="card h-100 hover-lift" style={{
                                background: 'linear-gradient(135deg, #3498db, #9b59b6)',
                                color: 'white',
                                border: 'none'
                            }}>
                                <div className="card-body d-flex align-items-center" style={{ gap: '14px' }}>
                                    <div style={{ fontSize: '1.8rem' }}>🎬</div>
                                    <div style={{ flex: 1 }}>
                                        <h6 className="mb-1" style={{ color: 'white' }}>Tag 3 — Urheberrecht &amp; Videos</h6>
                                        <p className="mb-0 small" style={{ opacity: 0.92 }}>Premiere morgen 12:45 Uhr — ihr seid eingeladen.</p>
                                    </div>
                                    <div style={{ fontWeight: 700, opacity: 0.9 }}>→</div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <a href="/pfingsten-2026/eltern-tag-4.html" className="text-decoration-none">
                            <div className="card h-100 hover-lift" style={{
                                background: 'linear-gradient(135deg, #00d084, #3498db)',
                                color: 'white',
                                border: 'none'
                            }}>
                                <div className="card-body d-flex align-items-center" style={{ gap: '14px' }}>
                                    <div style={{ fontSize: '1.8rem' }}>🎉</div>
                                    <div style={{ flex: 1 }}>
                                        <h6 className="mb-1" style={{ color: 'white' }}>Tag 4 — Abschluss &amp; Premiere</h6>
                                        <p className="mb-0 small" style={{ opacity: 0.92 }}>Cybermobbing-Block, Schnitt-Werkstatt &amp; Mini-Film-Premiere.</p>
                                    </div>
                                    <div style={{ fontWeight: 700, opacity: 0.9 }}>→</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            {/* Idee der Woche */}
            <div className="alert mb-4" style={{ background: '#e3f2fd', borderLeft: '4px solid #2196f3' }}>
                <h5 className="alert-heading" style={{ color: '#1976d2' }}>Die Idee der Woche</h5>
                <p className="mb-0">
                    Die Kinder verbringen Stunden mit TikTok, YouTube, Roblox. Dieses Camp dreht den Spieß um:
                    Wir <strong>zerlegen</strong>, was sie täglich sehen — Filter, Algorithmen, Werbung, Fake-Profile, Suchtmechanismen.
                    Und damit das nicht im Kopf bleibt, machen sie nebenher etwas Eigenes:
                    eine Persona, einen Foto-Comic, einen eigenen Mini-Film. Aufklärung als Hauptthema, Content Creation als Werkzeug.
                </p>
            </div>

            {/* Rechnungen */}
            {invoices.length > 0 && (
                <div className="card mb-4" style={{ borderLeft: '4px solid #00d084' }}>
                    <div className="card-header d-flex justify-content-between align-items-center" style={{ background: 'rgba(0,208,132,0.1)' }}>
                        <h4 className="mb-0" style={{ color: '#00d084' }}>Deine Rechnungen</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Rechnungs-Nr.</th>
                                        <th>Kind</th>
                                        <th>Betrag</th>
                                        <th>Status</th>
                                        <th>Aktion</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoices.map(invoice => (
                                        <tr key={invoice.id}>
                                            <td><strong>{invoice.invoice_number}</strong></td>
                                            <td>{invoice.child_name || '-'}</td>
                                            <td>
                                                {formatCurrency(invoice.total)}
                                                {invoice.discount > 0 && (
                                                    <small className="text-success d-block">
                                                        inkl. {invoice.discount_reason || 'Rabatt'}
                                                    </small>
                                                )}
                                            </td>
                                            <td>{getStatusBadge(invoice.status)}</td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => downloadPDF(invoice.id, invoice.invoice_number)}
                                                >
                                                    PDF
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="mt-3 p-3 rounded" style={{ background: '#f5f5f0' }}>
                            <strong>Zahlungsinformationen:</strong><br/>
                            Kontoinhaber: Futurhinos<br/>
                            IBAN: DE66 5001 0517 6000 5878 84<br/>
                            BIC: INGDDEFFXXX<br/>
                            <small className="text-muted">Bitte die Rechnungsnummer als Verwendungszweck angeben.</small>
                        </div>
                    </div>
                </div>
            )}

            {/* Wichtige Infos */}
            <div className="card mb-4" style={{ borderLeft: '4px solid #0693e3' }}>
                <div className="card-header" style={{ background: 'rgba(6,147,227,0.1)' }}>
                    <h4 className="mb-0" style={{ color: '#0693e3' }}>Wichtige Infos zum Camp</h4>
                </div>
                <div className="card-body">
                    <div className="row g-4">
                        <div className="col-md-4">
                            <h6><strong>Wann & Wo</strong></h6>
                            <p className="mb-2">
                                <strong>Datum:</strong> 26.05. - 29.05.2026<br/>
                                <strong>Zeit:</strong> 09:00 - 13:00 Uhr
                            </p>
                            <p className="mb-0">
                                <strong>Adresse:</strong><br/>
                                Futurhinos for Kids<br/>
                                Gottlieb-Daimler-Str. 36<br/>
                                73614 Schorndorf
                            </p>
                        </div>
                        <div className="col-md-4">
                            <h6><strong>Was mitbringen?</strong></h6>
                            <ul className="mb-0">
                                <li>Bequeme Kleidung</li>
                                <li>Optional: Buch o.ä. für die Randzeiten</li>
                            </ul>
                            <p className="mt-2 mb-0">
                                <small className="text-muted">Snacks, Mittagessen & Laptops/Tablets werden von uns gestellt.</small>
                            </p>
                        </div>
                        <div className="col-md-4">
                            <h6><strong>Kontakt</strong></h6>
                            <p className="mb-2">
                                <strong>Email:</strong><br/>
                                <a href="mailto:info@futurhinos.de">info@futurhinos.de</a>
                            </p>
                            <p className="mb-0">
                                <strong>Telefon:</strong><br/>
                                <a href="tel:+4915129464490">0151 2946 4490</a><br/>
                                <small className="text-muted">(auch WhatsApp)</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Randzeiten */}
            <div className="alert mb-4" style={{ background: '#fff3e0', borderLeft: '4px solid #ff9800' }}>
                <h5 className="alert-heading" style={{ color: '#e65100' }}>Randzeiten: 8:00 - 9:00 Uhr & 13:00 - 14:00 Uhr</h5>
                <p className="mb-0">
                    Ihr könnt eure Kinder bereits <strong>ab 8:00 Uhr</strong> bringen und <strong>bis 14:00 Uhr</strong> abholen.
                    Das ist keine Betreuung im klassischen Sinne - wir sind da und kümmern uns bei Fragen,
                    aber für die Beschäftigung in dieser Zeit sind die Kinder selbst verantwortlich.
                </p>
            </div>

            {/* Die vier Tage */}
            <h2 className="mb-3" style={{ color: '#f810b1' }}>Die vier Themen-Tage</h2>
            <div className="row g-4 mb-4">
                <div className="col-md-6 col-lg-3">
                    <a href="/pfingsten-2026/tag-1/" className="text-decoration-none">
                        <div className="card h-100 hover-lift">
                            <div className="card-header text-white" style={{ background: 'linear-gradient(135deg, #f810b1, #9b59b6)' }}>
                                <strong>Di · 26.05.</strong>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title" style={{ color: '#324047' }}>Blick hinter die Kulissen</h5>
                                <p className="small mb-2" style={{ color: '#666' }}>
                                    Clip-Analyse: Was sehen wir, was nicht? Wer verdient daran? Plus Filter live demonstriert.
                                </p>
                                <span className="badge mt-1" style={{ background: '#f810b1' }}>Tag öffnen</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-6 col-lg-3">
                    <a href="/pfingsten-2026/tag-2/" className="text-decoration-none">
                        <div className="card h-100 hover-lift">
                            <div className="card-header text-white" style={{ background: 'linear-gradient(135deg, #ff6b35, #e74c3c)' }}>
                                <strong>Mi · 27.05.</strong>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title" style={{ color: '#324047' }}>Algorithmen & Schutzschild</h5>
                                <p className="small mb-2" style={{ color: '#666' }}>
                                    Wie machen Apps süchtig? Datenschutz-Einstellungen, Fake-Profile, Cybermobbing.
                                </p>
                                <span className="badge mt-1" style={{ background: '#ff6b35' }}>Tag öffnen</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-6 col-lg-3">
                    <a href="/pfingsten-2026/tag-3/" className="text-decoration-none">
                        <div className="card h-100 hover-lift">
                            <div className="card-header text-white" style={{ background: 'linear-gradient(135deg, #3498db, #9b59b6)' }}>
                                <strong>Do · 28.05.</strong>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title" style={{ color: '#324047' }}>Urheberrecht & Fußabdruck</h5>
                                <p className="small mb-2" style={{ color: '#666' }}>
                                    Was darf ich teilen? Was bleibt im Netz? Eigene Mini-Filme drehen — mit lizenzfreier Musik.
                                </p>
                                <span className="badge mt-1" style={{ background: '#3498db' }}>Tag öffnen</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-6 col-lg-3">
                    <a href="/pfingsten-2026/tag-4/" className="text-decoration-none">
                        <div className="card h-100 hover-lift">
                            <div className="card-header text-white" style={{ background: 'linear-gradient(135deg, #00d084, #3498db)' }}>
                                <strong>Fr · 29.05.</strong>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title" style={{ color: '#324047' }}>Was zeige ich, was nicht</h5>
                                <p className="small mb-2" style={{ color: '#666' }}>
                                    Privatsphäre-Entscheidungen. Mini-Film schneiden. Um 12:45 Premiere für die Eltern.
                                </p>
                                <span className="badge mt-1" style={{ background: '#00d084' }}>Tag öffnen</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            {/* Vier Aufklärungs-Säulen */}
            <div className="card mb-4">
                <div className="card-header">
                    <h4 className="mb-0">Die vier Aufklärungs-Säulen</h4>
                </div>
                <div className="card-body">
                    <div className="row g-4">
                        <div className="col-md-6 col-lg-3">
                            <h6 style={{ color: '#f810b1' }}>Realität vs. Filter</h6>
                            <p className="small mb-0">Was bearbeitet ist, wir es erkennen. Algorithmen verstehen. Geschäftsmodelle dahinter.</p>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6 style={{ color: '#ff6b35' }}>Schutzschild im Netz</h6>
                            <p className="small mb-0">Datenschutz-Einstellungen. Fake-Profile. Cybermobbing-Prävention. Wem sage ich es?</p>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6 style={{ color: '#3498db' }}>Urheberrecht</h6>
                            <p className="small mb-0">Was darf ich teilen? Musik, Bilder, Stimmen. Lizenzfreie Quellen.</p>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6 style={{ color: '#00d084' }}>Digitaler Fußabdruck</h6>
                            <p className="small mb-0">Was bleibt im Netz — auch nach Löschen? Was zeige ich, was bleibt privat?</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Tagesablauf */}
            <div className="card mb-4" style={{ borderLeft: '4px solid #f810b1' }}>
                <div className="card-header" style={{ background: 'rgba(248,16,177,0.1)' }}>
                    <h4 className="mb-0" style={{ color: '#f810b1' }}>Tagesablauf (gilt für alle vier Tage)</h4>
                </div>
                <div className="card-body">
                    <div className="row g-2">
                        {[
                            { zeit: '08:00 - 09:00', label: 'Ankommen', detail: 'Open Space', color: '#324047' },
                            { zeit: '09:00 - 09:15', label: 'Check-in', detail: 'Tagesthema', color: '#f810b1' },
                            { zeit: '09:15 - 10:45', label: 'Aufklärungs-Block', detail: 'Clips, Diskussion, Demos', color: '#f810b1' },
                            { zeit: '10:45 - 11:15', label: 'Pause', detail: 'Snack, Bewegung, Mittagessen abstimmen', color: '#00d084' },
                            { zeit: '11:15 - 12:30', label: 'Doing-Block', detail: 'eigene Persona / Comic / Film bauen', color: '#f810b1' },
                            { zeit: '12:30 - 12:50', label: 'Mittagessen', detail: 'gemeinsam', color: '#324047' },
                            { zeit: '12:50 - 13:00', label: 'Show & Tell', detail: 'Tagesabschluss', color: '#324047' },
                            { zeit: '13:00 - 14:00', label: 'Abholfenster', detail: '', color: '#324047' },
                        ].map((item, idx) => (
                            <div key={idx} className="col-12 d-flex gap-3 align-items-center py-2 border-bottom">
                                <span className="badge" style={{ background: item.color, minWidth: '130px' }}>{item.zeit}</span>
                                <span><strong>{item.label}</strong>{item.detail && <> · {item.detail}</>}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Gruppen-Info */}
            <div className="card mb-4" style={{ borderLeft: '4px solid #9b59b6' }}>
                <div className="card-header" style={{ background: 'rgba(155,89,182,0.1)' }}>
                    <h4 className="mb-0" style={{ color: '#9b59b6' }}>Die Gruppe diese Woche</h4>
                </div>
                <div className="card-body">
                    <p>Drei Kinder zwischen 8 und 10 Jahren, technisch versiert und neugierig. Sie sind digital fit, aber das ist genau der Grund, warum die Aufklärung jetzt zählt:</p>
                    <ul className="mb-0">
                        <li><strong>Doing kurz, Reden länger</strong> — Diskussionen werden hier zum Hauptevent</li>
                        <li><strong>Echte Clips zerlegen</strong> — nicht abstrakt, sondern Sachen, die sie selbst täglich sehen</li>
                        <li><strong>Persona als Schutzschild</strong> — sie spielen eine erfundene Figur, nicht sich selbst</li>
                        <li><strong>Eigener Mini-Film</strong> — Live-Action mit der Kamera am Donnerstag, Schnitt in CapCut am Freitag</li>
                    </ul>
                </div>
            </div>

            {/* Hinweis für Eltern */}
            <div className="alert" style={{ background: 'rgba(6,147,227,0.15)', color: '#0577b8' }}>
                <h5 className="alert-heading">Hinweis für Eltern</h5>
                <p className="mb-0">
                    Wir behandeln in dieser Woche bewusst auch Themen wie Cybermobbing, Sucht-Mechaniken
                    und Privatsphäre. Wenn euer Kind nach dem Camp Fragen hat oder etwas auffällt, sprecht uns
                    gerne direkt an — wir geben euch jeden Abend einen kurzen Update, was wir gemacht haben.
                </p>
            </div>
        </div>
    );
}

export default SocialMediaProsWorkshop;
